"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remindSharedDocumentRecipientsApiResponseSchema = exports.listSharedDocumentNotificationsApiResponseSchema = exports.sharedDocumentNotificationApiResponseSchema = exports.listSharedDocumentRecipientsApiResponseSchema = exports.sharedDocumentRecipientApiResponseSchema = exports.getSharedDocumentTrackingApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const shared_document_1 = require("./shared-document");
const shared_document_administration_1 = require("./shared-document-administration");
const shared_document_notification_1 = require("./shared-document-notification");
/**
 * One document as the administration follows it: what it is, who published
 * it, what it targets — people named too — and its four counters over its
 * current recipients.
 */
exports.getSharedDocumentTrackingApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('shared-documents'),
        attributes: zod_1.z.object({
            title: zod_1.z.string(),
            description: zod_1.z.string().nullable(),
            fileName: zod_1.z.string(),
            /** Size in bytes. */
            fileSize: zod_1.z.number().int(),
            audience: shared_document_administration_1.sharedDocumentAudienceSchema,
            scopeType: shared_document_administration_1.sharedDocumentScopeTypeSchema,
            /** Sites, offices or people by name; closed places flagged. */
            targets: zod_1.z.array(shared_document_administration_1.sharedDocumentTargetSummarySchema),
            mandatoryRead: zod_1.z.boolean(),
            notifyByEmail: zod_1.z.boolean(),
            publishedAt: zod_1.z.coerce.date(),
            /** `null` once the publishing user no longer exists. */
            publishedBy: zod_1.z
                .object({ firstName: zod_1.z.string(), lastName: zod_1.z.string() })
                .nullable(),
            /** Current recipients only, as every counter below. */
            recipientCount: zod_1.z.number().int(),
            openedCount: zod_1.z.number().int(),
            /** 0 when the reading is not mandatory. */
            confirmedCount: zod_1.z.number().int(),
            /** Never opened, or a mandatory read not confirmed: who a reminder reaches. */
            noResponseCount: zod_1.z.number().int(),
        }),
    }),
});
/** A site or an office a recipient is attached to. */
const recipientPlaceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
});
/** One current recipient of a document, with where they stand. */
exports.sharedDocumentRecipientApiResponseSchema = zod_1.z.object({
    /** The recipient's user. */
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('shared-document-recipients'),
    attributes: zod_1.z.object({
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
        email: zod_1.z.string(),
        audience: shared_document_administration_1.sharedDocumentAudienceSchema,
        /** A substitute's sites; empty for the other profiles. */
        sites: zod_1.z.array(recipientPlaceSchema),
        /** An attending doctor's or an assistant's offices; empty for substitutes. */
        offices: zod_1.z.array(recipientPlaceSchema),
        status: zod_1.z.enum(shared_document_1.sharedDocumentReadStatuses),
        /** `null` while never opened. */
        firstOpenedAt: zod_1.z.coerce.date().nullable(),
        /** `null` until a mandatory read is confirmed. */
        confirmedAt: zod_1.z.coerce.date().nullable(),
    }),
});
exports.listSharedDocumentRecipientsApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.sharedDocumentRecipientApiResponseSchema).extend({
    /** Current recipients of the status asked for, across every page. */
    total: zod_1.z.number().int(),
});
/** One e-mail of a document's send log. */
exports.sharedDocumentNotificationApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('shared-document-notifications'),
    attributes: zod_1.z.object({
        /** `null` once the recipient's user no longer exists. */
        recipientName: zod_1.z.string().nullable(),
        /** The address as it was when the e-mail was queued. */
        recipientEmail: zod_1.z.string(),
        kind: zod_1.z.enum(shared_document_notification_1.sharedDocumentNotificationKinds),
        status: zod_1.z.enum(shared_document_notification_1.sharedDocumentNotificationStatuses),
        /** When it was queued. */
        createdAt: zod_1.z.coerce.date(),
        /** When it left `pending`; `null` while pending. */
        processedAt: zod_1.z.coerce.date().nullable(),
    }),
});
exports.listSharedDocumentNotificationsApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.sharedDocumentNotificationApiResponseSchema).extend({
    /** E-mails of the document, across every page. */
    total: zod_1.z.number().int(),
});
exports.remindSharedDocumentRecipientsApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        /** Reminder e-mails queued, one per recipient who still owes a reading. */
        queuedEmailCount: zod_1.z.number().int(),
    }),
});
